export default {"src":"/_next/static/media/logo.57fa8105.svg","height":39,"width":135};